
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-attribution-fill",
  "use": "icon-material-attribution-fill-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-attribution-fill\"><path d=\"M436.48-209.15h88.04v-178.81h57.52V-569.5q0-23.78-25.19-35.16t-76.35-11.38-76.85 11.37q-25.69 11.38-25.69 35.15v182.16h58.52zM480-74.02q-85.2 0-159.28-31.48-74.07-31.48-128.9-86.32-54.84-54.83-86.32-128.9Q74.02-394.8 74.02-480q0-84.92 31.48-159.14 31.48-74.21 86.28-129.06 54.81-54.85 128.9-86.43 74.09-31.59 159.32-31.59 84.92 0 159.11 31.55 74.19 31.54 129.1 86.46 54.92 54.91 86.46 129.1 31.55 74.19 31.55 159.11 0 85.23-31.59 159.32-31.58 74.09-86.43 128.9-54.85 54.8-129.06 86.28Q564.92-74.02 480-74.02m0-571.02q22.92 0 38.22-15.18t15.3-38.11q0-22.92-15.3-38.22T480-751.85t-38.22 15.3-15.3 38.22q0 22.93 15.3 38.11T480-645.04\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-attribution-fill"/>
                </svg>
            );
        };

        Icon.id = "icon-material-attribution-fill";

        export default Icon;
    